import React from "react";
import { AlertDialog, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { inr } from "@/lib/tps";

/**
 * Modal shown when user marks an order as Delivered while a balance is pending.
 * Owner variant shows the amount and label "Yes, Payment Received". Staff variant
 * hides the amount and uses "Yes, Collected".
 *
 * Props:
 *   open (bool)
 *   onCancel ()          — user cancels the whole action
 *   onCollect ()         — Yes, collect balance and mark delivered
 *   onDeliverOnly ()     — No, mark delivered without collecting
 *   balance (number)
 *   isOwner (bool)
 */
export default function DeliveryConfirmModal({ open, onCancel, onCollect, onDeliverOnly, balance, isOwner }) {
  return (
    <AlertDialog open={open} onOpenChange={(v) => { if (!v) onCancel(); }}>
      <AlertDialogContent data-testid="delivery-confirm-modal">
        <AlertDialogHeader>
          <AlertDialogTitle>
            {isOwner ? "Balance Payment Pending" : "Payment confirmation needed"}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {isOwner ? (
              <>This order has a pending balance of <strong data-testid="modal-balance-amount">{inr(balance)}</strong>. Has the balance payment been received?</>
            ) : (
              <>Was the pending balance collected?</>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-wrap gap-2">
          <Button variant="outline" className="h-9 border-[#E8E3DF]" onClick={onCancel} data-testid="delivery-modal-cancel">Cancel</Button>
          <Button variant="outline" className="h-9 border-[#E8E3DF]" onClick={onDeliverOnly} data-testid="delivery-modal-deliver-only">
            {isOwner ? "No, Mark Delivered Only" : "No, Not Collected"}
          </Button>
          <Button className="h-9 bg-[#B86F77] hover:bg-[#A35D65]" onClick={onCollect} data-testid="delivery-modal-collect">
            {isOwner ? "Yes, Payment Received" : "Yes, Collected"}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
